/* Bundle LP — extra interactions + reveals (loads after serum-lp.js + motion.js) */

/* --- Variant selector chips (Serum / Mask) ----------------------------- */
(function () {
  document.querySelectorAll('.bb-sel').forEach(function (group) {
    var btns = group.querySelectorAll('button');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) { o.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
  });
})();

/* --- GSAP reveals for bundle-only sections ----------------------------- */
(function () {
  if (!window.gsap || !window.ScrollTrigger) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var EASE = 'power3.out';

  // single elements rise in
  ['.routine .head', '.dewfav .dewfav__body', '.whenuse .head', '.bb__sub']
    .forEach(function (sel) {
      gsap.utils.toArray(sel).forEach(function (el) {
        gsap.from(el, { opacity: 0, y: 26, duration: 0.9, ease: EASE,
          scrollTrigger: { trigger: el, start: 'top 88%' } });
      });
    });

  // image reveals
  gsap.utils.toArray('.dewfav__media').forEach(function (el) {
    gsap.from(el, { opacity: 0, y: 36, scale: 0.96, duration: 1, ease: EASE,
      scrollTrigger: { trigger: el, start: 'top 85%' } });
  });

  // staggered groups
  [['.routine__list', '.rcard'], ['.checklist', 'li'],
   ['.ba__inner', '.ba__item'], ['.whenuse__grid', '.wcard']]
    .forEach(function (pair) {
      gsap.utils.toArray(pair[0]).forEach(function (g) {
        gsap.from(g.querySelectorAll(pair[1]), {
          opacity: 0, y: 30, duration: 0.7, ease: EASE, stagger: 0.08,
          scrollTrigger: { trigger: g, start: 'top 84%' }
        });
      });
    });

  ScrollTrigger.refresh();
})();
